import {
  COMPANY_CRYPTO_WALLET,
  CREATE_AMB_PAYMENT_RESPONSE,
  CREATE_CRYPTO_DEPOSIT,
  CREATED_DEPOSIT,
  THIRD_PARTY_PAYMENT_PROVIDER
} from '~/utils/api-response/finance'
import { PLAYER_DEPOSIT_IS_EXIST } from '~/utils/api-response/player'

// State
export const state = () => ({
  tempData: {},
  thirdPartyPayments: [],
  depositFlow: {},
  checkExist: {},
  checkDeposit: false,
  companyCryptoWallet: []
})

// Actions
export const actions = {
  create({ commit }, data) {
    const cloneData = JSON.parse(JSON.stringify(data))
    CREATED_DEPOSIT.data.deposit_amount = cloneData.amount
    CREATED_DEPOSIT.data.actual_deposit_amount = cloneData.amount
    const response = JSON.parse(JSON.stringify(CREATED_DEPOSIT))
    commit('setTempData', response.data)
    return response.data
  },
  confirm({ commit }, id) {
    try {
      // await this.$axios.put(`/deposits/${id}`, {})
      commit('checkDeposit', true)
      return true
    } catch (error) {
      return false
    }
  },
  revoke({ commit }, id) {
    try {
      commit('checkDeposit', false)
      return true
    } catch (error) {
      return false
    }
  },
  checkExist({ commit }, _) {
    const response = PLAYER_DEPOSIT_IS_EXIST
    commit('checkExist', response.data)
  },
  getThirdPartyPayments({ commit }, _) {
    const response = THIRD_PARTY_PAYMENT_PROVIDER
    commit('setThirdPartyPayments', response.data)
  },
  async depositFlow({ commit }, currency) {
    try {
      const response = await this.$axios.get(`website-setting/deposit-flow/${currency}`)
      commit('depositFlow', response.data)
      // commit('depositFlow', {
      // 	deposit_type: 2,
      // 	is_bank_transfer_enabled: true,
      // 	is_third_party_payment_enabled: true
      // })
    } catch (error) {}
  },
  depositCrypto({ _ }, data) {
    try {
      const response = CREATE_CRYPTO_DEPOSIT
      return response.data
    } catch (error) {
      return false
    }
  },
  createDepositThirdParty({ commit }, body) {
    const windowLink = window.open()
    try {
      const data = JSON.parse(JSON.stringify(body))
      CREATE_AMB_PAYMENT_RESPONSE.data.deposit_amount = data.amount
      const response = JSON.parse(JSON.stringify(CREATE_AMB_PAYMENT_RESPONSE))
      commit('setTempData', response.data)
      if (response.data.is_qr) {
        // Make sure to change the logic in amb page
        // Save the deposit id with the qr_code storage to make sure the deposit is match with the qr code
        localStorage.setItem(
          'qr_code',
          `${response.data.id}:${encodeURIComponent(response.data.tp_payment_link)}`
        )

        windowLink.location = `/third-party-payment?amount=${
          response.data.deposit_amount
        }&currency=${response.data.currency}&created_at=${encodeURIComponent(
          response.data.created_at
        )}&tp_gateway_code=${response.data.tp_gateway_code}`
      } else {
        windowLink.location = getThirdPartyPaymentLinkByProvider(
          response.data.tp_payment_link,
          response.data.tp_gateway_code,
          this.$router
        )
      }
      return response.data
    } catch (error) {
      windowLink.close()
      return false
    }
  },
  getCompanyCryptoWallet({ commit }, params) {
    const response = COMPANY_CRYPTO_WALLET
    commit('setCompanyCryptoWallet', response.data)
    return response.data
  }
}

// Mutations
export const mutations = {
  setTempData: (state, data) => {
    state.tempData = data
  },
  setThirdPartyPayments: (state, data) => {
    state.thirdPartyPayments = data
  },
  depositFlow: (state, data) => {
    state.depositFlow = data
  },
  checkExist: (state, data) => {
    state.checkExist = data
  },
  checkDeposit: (state, data) => {
    state.checkDeposit = data
  },
  setCompanyCryptoWallet: (state, data) => {
    state.companyCryptoWallet = data
  }
}

// Function to generate payment links for different payment providers
const paymentLinkProviders = {
  third_party_papaya_pay: (link, router) =>
    `${link}?redirectionUrl=${window.location.origin}${router.currentRoute.fullPath}`
}

const getThirdPartyPaymentLinkByProvider = (link, provider, router) => {
  const generateLink = paymentLinkProviders[provider]
  return generateLink ? generateLink(link, router) : link
}
